import { Component, Input, OnInit, SimpleChanges, OnChanges, Output, EventEmitter } from '@angular/core';
import { NzFormatEmitEvent, NzTreeComponent, NzTreeNodeOptions } from 'ng-zorro-antd/tree';
import { CommonService } from '../../service/common/common.service';

@Component({
  selector: 'structure-select',
  templateUrl: './structure-select.component.html',
  styleUrls: ['./structure-select.component.less'],
})
export class StructureSelectComponent implements OnInit {
  /**
   * 数据源
   * {recommend:[],all:[]}
   */
  @Input() data: object = {};
  /**
   * 组件深度
   */
  @Input() index: number = 99;
  /**
   * 是否显示遮罩层
   */
  @Input() noMask: boolean = false;
  /**
   * 是否显示 boolean
   */
  @Input() show: boolean = false;
  /**
   * 选择模式 true 单选  false  多选
   */
  @Input() nzMultiple: boolean = false;
  /**
   * 组织架构
   */
  @Input() structure: Array<object> = [];

  @Input() checkData: Array<any> = [];
  /**
   * 确定事件
   */
  @Output() sure = new EventEmitter();
  /**
   * 取消事件
   */
  @Output() cancel = new EventEmitter();
  isAll: boolean = true; // 判断tab的类型 true  全部 false 推荐
  allStructure: Array<object> = [];
  selectIds: Array<any> = []; // 选择的推荐的id
  selectResult: Array<object> = []; // 选中数据
  leftSearch: string = ''; // 左侧检索关键字
  leftSearchResult: Array<object> = [];
  rightSearch: string = ''; // 右侧检索关键字
  searchData: Array<any> = []; // 检索后的部门数据
  checkAll: boolean = false; // 是否全选

  constructor(private common: CommonService) {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['structure'] != undefined) {
      if (this.structure.length != 0) {
        this.allStructure = this.dealStructure(this.structure);
      } else {
        this.allStructure = [];
      }
    }
    if (changes['show']) {
      if (this.show === true) {
        // 回显选中数据
        this.selectResult = [...this.checkData];
        const selectIds = [];
        this.checkData.map((item) => {
          selectIds.push(item['key']);
        });
        this.selectIds = [...selectIds];
        if (this.structure.length != 0) {
          this.allStructure = this.dealStructure(this.structure);
        } else {
          this.allStructure = [];
        }

      } else {
        this.clearSearch();
      }
    }
    if (changes['noMask']) {
      this.noMask = true;
    }
  }

  /**
   * 处理组织架构
   */
  dealStructure(data: Array<object>, level: number = 0): any {
    const response: Array<object> = [];
    for (const structure of data) {
      const item = {};
      item['title'] = structure['organ_name'];
      item['key'] = structure['organ_id'];
      item['value'] = structure['organ_id'];
      item['parent'] = structure['organ_pid'];
      item['status'] = structure['status'];
      if (level == 0) {
        item['selectable'] = false;
        item['disableCheckbox'] = true;
        item['expanded'] = true;
      }
      Object.assign(item, structure);
      // 如果当前数据是已选中数据则设置数据源中的selected和checked 为true
      if (this.selectIds.indexOf(item['key']) > -1) {
        item['selected'] = true;
        item['checked'] = true;
      } else {
        item['selected'] = false;
        item['checked'] = false;
      }
      // 清除冗余数据
      delete item['child_node'];
      // 如果子数据不为空则进行递归
      if (structure['child_node'].length > 0) {
        level++;
        item['children'] = this.dealStructure(structure['child_node'], level);
      } else {
        item['isLeaf'] = true;
      }
      response.push(item);
    }
    return response;
  }

  /**
   * 移除选择到的选项
   * @param item
   * @param index
   */
  delete(item: object, index: number): void {
    const selectResult = [...this.selectResult];
    const selectIds = [...this.selectIds];
    selectResult.splice(index, 1);
    const selectIndex = selectIds.indexOf(item['key']);
    selectIds.splice(selectIndex, 1);
    this.selectResult = [...selectResult];
    this.selectIds = [...selectIds];
    this.decisionCheckAll();
  }

  /**
   * 右侧检索
   * @param $event
   */
  setRightSearch($event: any): void {
    this.rightSearch = $event;
  }

  /**
   * 清空所有选择
   */
  clear(): void {
    this.selectIds = [...[]];
    this.selectResult = [...[]];
    this.checkAll = false;
  }

  /**
   * 输出结果
   */
  putResult(): void {
    this.sure.emit({ event: 'sure', target: this.selectResult });
    this.clearSearch();

    console.log(this.selectIds);
  }

  close(): void {
    const selectIds = [];
    this.checkData.map((item) => {
      selectIds.push(item['key']);
    });
    this.selectIds = [...selectIds];
    this.selectResult = [...this.checkData];
    this.cancel.emit({ event: 'cancel' });
  }

  /**
   * 选择部门
   * @param $event
   */
  selectItem($event: NzFormatEmitEvent): void {
    const item = $event.node.origin;
    const key = item.key;
    let selectIds = [...this.selectIds];
    let selectResult = [...this.selectResult];
    // 判断是单选还是多选
    if (!this.nzMultiple) {
      if (selectIds.indexOf(key) > -1) {
        this.selectResult.map((item, index) => {
          if (item['key'] == key) {
            selectResult.splice(index, 1);
          }
        });
        selectIds.splice(selectIds.indexOf(key), 1);
      } else {
        item['organ_all_path'] = this.recursiveResult($event.node)
          .split(',')
          .filter((s) => {
            return s && s.trim();
          })
          .join('/');
        selectResult.push(item);
        selectIds.push(key);
      }
    } else {
      if (selectIds.indexOf(key) > -1) {
        selectIds = [];
        selectResult = [];
      } else {
        selectIds = [];
        selectResult = [];
        item['organ_all_path'] = this.recursiveResult($event.node)
          .split(',')
          .filter((s) => {
            return s && s.trim();
          })
          .join('/');
        selectResult.push(item);
        selectIds.push(key);
      }
    }
    this.selectIds = [...selectIds];
    this.selectResult = [...selectResult];
  }

  /**
   * 递归处理方法
   * @param data
   */
  recursiveResult(data: any, organ_all_path: string = ''): any {
    organ_all_path = data.origin.title + ',' + organ_all_path;
    if (data.parentNode != null) {
      organ_all_path = this.recursiveResult(data.parentNode, organ_all_path);
    }
    return organ_all_path;
  }

  /**
   * 清理检索信息
   */
  clearSearch(): void {
    this.leftSearch = '';
    this.searchData = [];
  }

  /**
   * 检索部门
   * @param $event
   */
  searchDepart($event: any): void {
    this.leftSearch = $event.target.value;
    if ($event.target.value == '') {
      return;
    }
    this.common
      .ajax({
        url: 'organ/getDepartTreeByDepartName',
        data: { organ_name: $event.target.value },
        loading: true,
        success: (res) => {
          const _searchData = [];
          res.forEach((item) => {
            _searchData.push({
              key: item['organ_id'],
              title: item['organ_name'],
              path: item['organ_all_path'],
              ...item,
            });
          });
          this.searchData = [..._searchData];
          this.decisionCheckAll();
        },
      })
      .then((res) => {
      });
  }

  /**
   * 全选
   * @param $event
   */
  allCheck($event: any): void {
    const _selectIds = [...this.selectIds];
    const _selectResult = [...this.selectResult];
    if (!$event) {
      this.searchData.forEach((item) => {
        if (_selectIds.indexOf(item.key) > -1) {
          _selectIds.splice(_selectIds.indexOf(item.key), 1);
          _selectResult.forEach((i, index) => {
            if (item['key'] == i['key']) {
              _selectResult.splice(index, 1);
            }
          });
        }
      });
    } else {
      this.searchData.forEach((item) => {
        if (_selectIds.indexOf(item.key) == -1) {
          _selectIds.push(item.key);
          _selectResult.push(item);
        }
      });
    }
    this.selectIds = [..._selectIds];
    this.selectResult = [..._selectResult];
    this.decisionCheckAll();
  }

  /**
   * 点选检索数据
   * @param key
   * @param index
   * @param $event
   */
  selectData(key: any, index: number, $event: any): void {
    let _selectIds = [...this.selectIds];
    let _selectResult = [...this.selectResult];
    // 判断是单选还是多选
    if (!this.nzMultiple) {
      if (_selectIds.indexOf(key) > -1) {
        _selectIds.splice(_selectIds.indexOf(key), 1);
        _selectResult.forEach((item, i) => {
          if (item['key'] == key) {
            _selectResult.splice(i, 1);
          }
        });
      } else {
        _selectIds.push(key);
        _selectResult.push(this.searchData[index]);
      }
    } else {
      if (_selectIds.indexOf(key) > -1) {
        _selectIds = [];
        _selectResult = [];
      } else {
        _selectIds = [key];
        _selectResult = [this.searchData[index]];
      }
    }
    this.selectIds = [..._selectIds];
    this.selectResult = [..._selectResult];
    this.decisionCheckAll();
  }

  private decisionCheckAll(): void {
    // 判断推荐数据是否已经全选
    const _checkAll = this.searchData.every((item) => {
      return this.selectIds.indexOf(item['key']) > -1;
    });
    this.checkAll = _checkAll;
  }
}
